module.exports = __webpack_public_path__ + "static/img/circle06.197d408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle06.png
// module id = II5Z
// module chunks = 10